module.exports = __webpack_public_path__ + "static/media/start-flag.61a53383.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/start-flag.svg
// module id = 687
// module chunks = 0